import type { ControlResultListItemResponseDto } from "@/spz-api/model";
import { Toggle } from "@spz/ui/components/toggle";
import {
  TreeSearchableSelect,
  type TreeSection,
} from "@spz/ui/components/tree-searchable-select";
import type { Table } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { useControlResultConclusionFiltersViewModel } from "../view-models/control-result-conclusion-filters.view-model";

export const ControlResultConclusionFilters = ({
  table,
  conclusionSections,
}: {
  table: Table<ControlResultListItemResponseDto>;
  conclusionSections: TreeSection[];
}) => {
  const { t } = useTranslation();

  const { isConclusionFilterSelected, value, onSelect, onModeToggle } =
    useControlResultConclusionFiltersViewModel({
      table,
    });

  const ConclusionFooter = () => (
    <div className="border-t border-gray-200 p-2">
      <Toggle
        label={t("show_conclusion_details")}
        checked={isConclusionFilterSelected}
        onCheckedChange={onModeToggle}
      />
    </div>
  );

  return (
    <TreeSearchableSelect
      placeholder={t("conclusion")}
      sections={conclusionSections}
      value={value}
      onSelect={onSelect}
      variant="ghost"
      footerRenderer={ConclusionFooter}
    />
  );
};
